export default {
  address: 'Morada',
  contact: 'Contacto',
  terms: 'Termos de Utilização',
  privacy_policy: 'Política de Privacidade',
  impressum: 'Impressum',
  cookie_policy: 'Política de Cookies',
  cookie_settings: 'Definições de cookies',
};
